
export enum Period {
  '3 Months' = 'R3',
  '6 Months' = 'R6',
  '12 Months' = 'R12'
}

export const PeriodOptions = Object.keys(Period) as (keyof typeof Period)[];

export interface hasDataFlags {
  locationPerformance: boolean;
  totalIssues: boolean;
  serviceMetrics: boolean;
  issuesComparison: boolean;
  locationInsights: boolean
}

export interface PerformanceData {
  gaugeNeedleValue: number;
  lineChartData: {
    xAxis: string[];
    yAxis: number[];
  };
  serviceMetricsChartData: number[];
  totalIssuesData: number[];
  totalIssuesMiddleText: number;
}

export interface IssuesCountData {
  comparisonChartData: number[];
  comparisonChartLabels: string[];
}

export interface MonthlyPerformanceData {
  month: string;
  performanceRating: number;
  noCallData: boolean;
}

export type topBottomLocationInsightsRow = {
  'accountNumber': string ,
  'accountName': string ,
  'city': string ,
  'issues': number ,
  'outOfProductIssues': number ,
  'performanceRating': number ,
  'recurringIssues': number ,
  'state':string,
  'street':string,
  'zipCode':string
}

export type LocationInsightsAdvancedFilters = {
  "accountName": string[],
  "city": string[],
  "state": string[],
  "performanceRating": string[],
}


export interface LocationDetails  {
  accountName: string;
  accountNumber: string;
  shippingStreet: string;
  shippingCity: string;
  shippingState: string;
  shippingPostalCd: string;
  shippingCountry: string;
  workOrderId: string;
  callReason: string;
  status: string;
  startDate: string;
  endDate: string;
  obsCount: number;
  issuesCount: number;
  observationNames: string;
  pdfBaseUrl : string;
  ecolabRep: string;
  virtualVisit: boolean;
  photoInfo: {
    photoBaseUrl: string;
    photoDescription: string;
  }[];
}

export const CALL_REASON_MAP: { [key: string]: string } = {
  'RSC': 'Routine Service Visit',
  'ESR': 'Extra Service Visit',
  'TRN': 'Training Visit',
  'INST': 'Install Visit',
  'PRC': 'Routine Service Visit',
  'QC': 'Admin Call',
  'Quick Call': 'Admin Call'
};

